// API-Hooks Benutzerverwaltung (/admin/user/). Antworten kommen im ACK-Envelope,
// client.ts entpackt: GET liefert { users, pagination }, POST liefert { user }.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { api, apiFetch } from './client'

export interface AdminUser {
  id: number
  email: string
  name: string
  permissions: Record<string, boolean | undefined>
  is_active: boolean
  created_at: string
  last_login_at: string | null
}

export function useAdminUsers(enabled: boolean) {
  return useQuery({
    queryKey: ['admin-users'],
    // Backend-Default waere 20 (max 100) — bei >100 Usern braucht es echte Pagination (bewusst YAGNI, aktuell <20 User)
    queryFn: () => api.get<{ users: AdminUser[] }>('/admin/user/?limit=100'),
    enabled,
  })
}

export interface SaveUserBody {
  email?: string
  name?: string
  password?: string
  permissions?: Record<string, boolean>
  is_active?: boolean
  pin?: string | null
}

export function useSaveUser() {
  const qc = useQueryClient()
  return useMutation({
    // ohne id: Anlegen (POST /admin/user/), mit id: Aendern (POST /admin/user/{id}/)
    mutationFn: (a: { id?: number; body: SaveUserBody }) =>
      apiFetch<{ user: AdminUser }>(a.id ? `/admin/user/${a.id}/` : '/admin/user/', {
        method: 'POST',
        body: JSON.stringify(a.body),
      }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['admin-users'] }),
    onError: (e) => toast.error(e instanceof Error ? e.message : 'Speichern fehlgeschlagen'),
  })
}
